<template>
    <div v-if="error" class="form-field__error">
        <common-icon name="forbidden" size="medium"></common-icon>
        <p>
            <slot>{{ error }}</slot>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'common-field-error',

        props: {
            error: {
                type: String,
                default: '',
            },
        },
    }
</script>
